import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';

/**
 * Angular's Arabic locale data for the date pipe (same approach as the main app's
 * `core/i18n/angular-locale.ts`). CLDR's Arabic data keeps Western digits (product rule: numbers stay in
 * English digits); its medium date is numeric, so switch it to the month-name form ("5 أكتوبر 2026").
 */
const DATE_FORMATS_INDEX = 10; // [short, medium, long, full]
const MEDIUM = 1;
let registered = false;

export function registerAppLocales(): void {
  if (registered) return;
  const data = [...(localeAr as unknown[])];
  const dateFormats = [...(data[DATE_FORMATS_INDEX] as string[])];
  dateFormats[MEDIUM] = 'd MMM y';
  data[DATE_FORMATS_INDEX] = dateFormats;
  registerLocaleData(data, 'ar');
  registered = true;
}

export function angularLocaleFor(lang: string): string {
  return lang.toLowerCase().startsWith('ar') ? 'ar' : 'en-US';
}
